import Button, { ButtonColor, ButtonSpacing, ButtonType } from './Button';

export { ButtonType, ButtonSpacing, ButtonColor };

export default Button;
